import { multipartFetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

export const createDocumentAssemblerTemplateVersion = async (
  templateId: string,
  params: Readonly<{ file: File; authorGuidance?: string }>
): Promise<Response> => {
  const body = new FormData();
  body.append('file', params.file);

  // Appended only when it carries prose. An empty part is stored as null anyway, and appending
  // `undefined` would send the literal string "undefined".
  const authorGuidance = params.authorGuidance?.trim();
  if (authorGuidance) body.append('authorGuidance', authorGuidance);

  return multipartFetcher(templateVersionsUrl(templateId), {
    method: 'POST',
    body,
  });
};
